/**
 * @param {Array<function>} fns
 * @returns {function:any}
 */
function compose() {
  for (var _len = arguments.length, fns = Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return fns.reduceRight(function (composed, fn) {
    return function () {
      return fn(composed.apply(undefined, arguments));
    };
  });
}

export default compose;


// WEBPACK FOOTER //
// ./node_modules/lyjs/es/fp/compose.js